import { render, staticRenderFns } from "./MigrationNotification.vue?vue&type=template&id=01d010ea&scoped=true"
import script from "./MigrationNotification.vue?vue&type=script&lang=js"
export * from "./MigrationNotification.vue?vue&type=script&lang=js"
import style0 from "./MigrationNotification.vue?vue&type=style&index=0&id=01d010ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d010ea",
  null
  
)

export default component.exports